import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

type Operation = (stationsFilter: StationsState['filteredStations']['filter']) => void;

export const updateStationsFilter: Operation = (stationsFilter) => stationsActions
  .setFilteredStationsFilter(stationsFilter);
